import React from 'react';
import PropTypes from 'prop-types';
import trackEvent from '../utils/trackEvent';
import { setClassNames } from '../utils/utility';

const DDCLogo = ({ color, label, classes, windowId }) => {
	return (
		<a
			href="https://www.dealer.com/"
			target="_blank"
			rel="noopener noreferrer"
			onClick={() => {
				trackEvent('Dealer.com', windowId);
			}}
			className={setClassNames(classes)}
		>
			<img
				src={`/static/assets/images/logos/dealer-dot-com/logo-one-color-${color}.svg`}
				alt={label}
				height="20"
				width="162"
			/>
		</a>
	);
};

DDCLogo.propTypes = {
	color: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	classes: PropTypes.string.isRequired,
	windowId: PropTypes.string.isRequired
};

export default DDCLogo;
